import PageHero from 'components/PageHero';
import { Scale } from 'lucide-react';

export default function Terms() {
  return (
    <div className="max-w-3xl prose prose-invert">
      <PageHero
        eyebrow="Legal"
        title="Terms & Conditions"
        showBack
        description="Last updated: July 2026"
        icon={<Scale size={16} className="text-tp-gold" />}
      />

      <section className="glass-panel mt-6 space-y-4 p-6 text-sm text-white/80">
        <h2 className="text-lg font-semibold text-white">1. Acceptance</h2>
        <p>By accessing and playing Teen Patti Classic on this platform, you agree to these terms and our responsible gaming policies.</p>

        <h2 className="text-lg font-semibold text-white">2. Eligibility</h2>
        <p>You must meet the legal age requirement for online gaming in your jurisdiction. One account per person is permitted.</p>

        <h2 className="text-lg font-semibold text-white">3. Virtual Currency</h2>
        <p>In-game chips represent virtual currency for entertainment. All balances, bets, and winnings are tracked in the immutable game ledger.</p>

        <h2 className="text-lg font-semibold text-white">4. Fair Play</h2>
        <p>Card shuffling, dealing, and hand evaluation are performed server-side. Collusion, bots, and exploitation of bugs are prohibited and may result in account suspension.</p>

        <h2 className="text-lg font-semibold text-white">5. Disconnects</h2>
        <p>If your connection drops during a hand, you may reconnect within the configured buffer period. Unresolved turns may auto-fold to keep the game fair for other players.</p>

        <h2 className="text-lg font-semibold text-white">6. Limitation of Liability</h2>
        <p>The platform is provided &quot;as is.&quot; We are not liable for losses arising from connectivity issues, device failures, or unauthorized account access due to shared credentials.</p>

        <h2 className="text-lg font-semibold text-white">7. Contact</h2>
        <p>For support or disputes, contact your platform operator through the official consumer integration channel.</p>
      </section>
    </div>
  );
}
